<div class="flex wrapper column">
  <div class="content flex">
    <div class="data">
      <p class="title font-H4">{{ "Providers.Trucks.PlateNumber" | translate }}</p>
      <p class="value font-H3">
        {{ data.plateNumber }} {{ plateNumberDetails?.leftCharEN }}{{ plateNumberDetails?.middleCharEN }}{{ plateNumberDetails?.rightCharEN}}
      </p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Inputs.PlateNumberDigits" | translate }}</p>
      <p class="value font-H3">{{ plateNumberDetails?.plateNumberDigits || '_______' }}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Inputs.PlateLettersAr" | translate }}</p>
      <p class="value font-H3">
        {{ plateNumberDetails?.rightCharAR || '____' }} {{ plateNumberDetails?.middleCharAR || '____' }} {{ plateNumberDetails?.leftCharAR
        || '____' }}
      </p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Inputs.PlateLettersEn" | translate }}</p>
      <p class="value font-H3">
        {{ plateNumberDetails?.leftCharEN || '____' }} {{ plateNumberDetails?.middleCharEN || '____' }} {{ plateNumberDetails?.rightCharEN
        || '____' }}
      </p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Trucks.LicenseExpiryDate"| translate }}</p>
      <p class="value font-H3">{{ data.licenseExpiryDate | date: 'd/M/yyyy' }}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Trucks.SponsorName" | translate }}</p>
      <p class="value font-H3">{{ data.ownerName | translate}}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Trucks.OwnerId" | translate }}
        <span> ({{ "Inputs.MOINumber" | translate }})</span>
      </p>
      <p class="value font-H3">{{ data.ownerId | translate}}</p>
    </div>
  </div>

  <div class="my-5">
    <mat-divider class="pos-static"></mat-divider>
  </div>

  <div class="flex actions">
    <button mat-raised-button class="btn-secondary btn" (click)="confirmed.emit(false)">{{ "Buttons.Cancel" | translate }}</button>
    <button mat-raised-button class="btn-primary btn" (click)="confirmed.emit(true)">{{ "Buttons.Confirm" | translate }}</button>
  </div>
</div>
